/** The prefix of the retargeting (nurturing pool) API error codes. */
export const RETARGETING_ERROR_CODE_PREFIX = 'lead.retargeting.';

/** The code a retargeting endpoint sends for a lead it cannot find. */
export const LEAD_NOT_FOUND_ERROR_CODE = 'lead.notFound';
